import React from 'react';
import { Badge } from '@/components/ui/badge';

interface FlowConnectionProps {
  label?: string;
  type?: 'default' | 'conditional' | 'parallel';
  isVertical?: boolean;
}

export const FlowConnection: React.FC<FlowConnectionProps> = ({
  label,
  type = 'default',
  isVertical = true,
}) => {
  const getConnectionStyle = () => {
    switch (type) {
      case 'conditional':
        return 'border-amber-500 border-dashed';
      case 'parallel':
        return 'border-blue-500';
      default:
        return 'border-primary/60';
    }
  };

  if (isVertical) {
    return (
      <div className="flex flex-col items-center py-2">
        {/* Arrow Line - Thicker with gradient effect */}
        <div className={`w-1 h-16 rounded-full ${getConnectionStyle()}`} />
        
        {/* Arrow Head - Larger */}
        <div className="relative">
          <div
            className={`w-0 h-0 border-l-[8px] border-l-transparent border-r-[8px] border-r-transparent border-t-[10px] ${
              type === 'conditional'
                ? 'border-t-amber-500'
                : type === 'parallel'
                ? 'border-t-blue-500'
                : 'border-t-primary/60'
            }`}
          />
          
          {/* Label */}
          {label && (
            <Badge
              variant="outline"
              className="absolute -right-16 top-1/2 -translate-y-1/2 text-xs whitespace-nowrap"
            >
              {label}
            </Badge>
          )}
        </div>
      </div>
    );
  }

  // Horizontal connection
  return (
    <div className="flex items-center px-2">
      {/* Arrow Line - Thicker */}
      <div className={`h-1 w-16 rounded-full ${getConnectionStyle()}`} />
      
      {/* Arrow Head - Larger */}
      <div className="relative">
        <div
          className={`w-0 h-0 border-t-[8px] border-t-transparent border-b-[8px] border-b-transparent border-l-[10px] ${
            type === 'conditional'
              ? 'border-l-amber-500'
              : type === 'parallel'
              ? 'border-l-blue-500'
              : 'border-l-primary/60'
          }`}
        />
        
        {/* Label */}
        {label && (
          <Badge
            variant="outline"
            className="absolute top-4 left-1/2 -translate-x-1/2 text-xs whitespace-nowrap"
          >
            {label}
          </Badge>
        )}
      </div>
    </div>
  );
};
